import { useState, useCallback } from 'react';

export type FormModalMode = 'create' | 'update';

interface UseFormModalReturn {
  visible: boolean;
  mode: FormModalMode;
  loading: boolean;
  showModal: (_mode: FormModalMode) => void;
  hideModal: () => void;
  setLoading: (_loading: boolean) => void;
}

export const useFormModal = (): UseFormModalReturn => {
  const [visible, setVisible] = useState(false);
  const [mode, setMode] = useState<FormModalMode>('create');
  const [loading, setLoading] = useState(false);

  const showModal = useCallback((modalMode: FormModalMode) => {
    setMode(modalMode);
    setVisible(true);
    setLoading(false);
  }, []);

  const hideModal = useCallback(() => {
    setVisible(false);
    setLoading(false);
  }, []);

  return {
    visible,
    mode,
    loading,
    showModal,
    hideModal,
    setLoading,
  };
};
